// import { useQuery } from '@tanstack/react-query'
import { endOfDay, format, startOfDay } from 'date-fns'
import { supabase } from '../../api'

type EventType = {
  fromDate: Date,
  search: string,
}

const getEventCount = async (
  table: string,
  type: string,
  index: number,
  date: Date,
  search: string,
) => {
  let req = supabase
    .from(table)
    .select('*', { count: 'exact', head: true })
    .gte('Event Date', format(startOfDay(date), 'yyyy-MM-dd\'T\'HH:mm:ssXX'))
    .lte('Event Date', format(endOfDay(date), 'yyyy-MM-dd\'T\'HH:mm:ssXX'))

  if (search && table === 'calendar_earnings') {
    req = req.or(
      `Symbol.ilike.%${search}%,Company.ilike.%${search}%,Event Name.ilike.%${search}%`,
    )
  }
  if (search && (table === 'calendar_stock_splits' || table === 'calendar_ipos')) {
    req = req.or(
      `Symbol.ilike.%${search}%,Company.ilike.%${search}%`,
    )
  }
  if (search && table === 'calendar_economic_events') {
    req = req.or(
      `Event.ilike.%${search}%`,
    )
  }
  const { count, error } = await req;

  if (error) {
    throw new Error(error.message)
  }

  return {
    index,
    type,
    count,
    date,
  };
}

const getEventCounts = ({ fromDate, search } : EventType) => {
  const bases = [{
    type: 'earnings',
    table: 'calendar_earnings',
  }, {
    type: 'stockSplits',
    table: 'calendar_stock_splits',
  }, {
    type: 'ipos',
    table: 'calendar_ipos',
  }, {
    type: 'economicEvents',
    table: 'calendar_economic_events',
  }]

  const promises: Promise<any>[] = [];

  bases.forEach((item, basesIndex) => {
    for (let i = 0; i < 7; i += 1) {
      const date = new Date(
        fromDate.getFullYear(),
        fromDate.getMonth(),
        fromDate.getDate() + i,
      )
      promises[(basesIndex * 7) + i] = getEventCount(item.table, item.type, i, date, search);
    }
  })

  return Promise.all(promises)
};

export default getEventCounts
